var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-0",attrs:{"app":"","color":"primary lighten-1","dark":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"primary py-3 text-center",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(_vm.copyrightText)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }